import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/sysBillNoRules/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/sysBillNoRules/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/sysBillNoRules/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/sysBillNoRules/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/sysBillNoRules/delete',
    method: 'post',
    data
  });
}

